import axios from 'axios';

class PostcodeService {
    static SearchPostcode = (postcode) => axios.get(`https://api.postcodes.io/postcodes/${postcode}`);
}

export default PostcodeService;